module.exports = __webpack_public_path__ + "img/stock6.64097be7.png";